import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { BefConfigProvider, BefGlobalProvider, BefLanguageServiceProvider, BefMessageControllerServiceProvider, BefMessageServiceProvider, BefRpcProvider, BefUserServiceProvider } from '@beflam/bef-core';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './Router';


ReactDOM.render(
  //服务依赖层级结构为，最外面是消息类，全局名，语言类
  <BrowserRouter>
    <BefMessageControllerServiceProvider>
      <BefMessageServiceProvider>
        <BefGlobalProvider>
          <BefLanguageServiceProvider>
            <BefRpcProvider>
              <BefUserServiceProvider>
                <BefConfigProvider>
                  <AppRouter />
                </BefConfigProvider>
              </BefUserServiceProvider>
            </BefRpcProvider>
          </BefLanguageServiceProvider>
        </BefGlobalProvider>
      </BefMessageServiceProvider>
    </BefMessageControllerServiceProvider>
  </BrowserRouter>,
  document.getElementById('root') as HTMLElement
);

console.log(React.version);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
